import { DEFAULT_IMAGE_URL } from '../../../../../../../common/constants/constants.js'

export const SCHEMAS = {
    structure: {
        version: '1.0.6',
        // order is important, new below!
        versionsList: ['1.0.6'],
        migrationTree: [
            {
                version: '1.0.6',
                downgrade: null,
                upgrade: null,
            },
            // Example
            // {
            //     version: '1.0.0',
            //     downgrade: null,
            //     upgrade: data => {
            //         data.testValue = true
            //         return {
            //             version: '1.0.1',
            //             data
            //         }
            //     },
            // }, {
            //     version: '1.0.1',
            //     downgrade: data => {
            //         delete data.testValue
            //         return {
            //             version: '1.0.0',
            //             data
            //         }
            //     },
            //     upgrade: data => {
            //         data.testValue = false
            //         return {
            //             version: '1.0.2',
            //             data
            //         }
            //     },
            // }, {
            //     version: '1.0.2',
            //     downgrade: data => {
            //         data.testValue = true
            //         return {
            //             version: '1.0.1',
            //             data
            //         }
            //     },
            //     upgrade: null,
            // }
        ],
        schema: {
            _v: '', // <String> structure version
            _isValid: undefined, // <Boolean> project is valid
            _settings: {
                // <Object> common settings
                showCover: undefined, // <Boolean> show cover
                distribution: [
                    // <Array> distribution
                    {
                        // <Object> distribution[i]
                        isVisible: undefined, // <Boolean> is visible
                        from: '', // <String> from
                        to: '', // <String> to
                    },
                ],
            },
            cover: {
                // <Object> cover
                header: '', // <String> header
                description: '', // <String> description
                image: undefined, // <null / String[URL]> image
                imageDisclaimer: '', // <String> image disclaimer
                buttonText: '', // <String> button text
            },
            questions: [
                // <Array> questions
                {
                    // <Object> questions[i]
                    id: undefined, // <String> id
                    text: '', // <String> text
                    image: undefined, // <null/String[URL]> image
                    imageDisclaimer: '', // <String> image disclaimer
                    isText: undefined, // <Boolean> is text question
                    answers: [
                        // <Array> answers
                        {
                            // <Object> answers[i]
                            id: undefined, // <String> id
                            text: '', // <String> text
                            description: '', // <String> description
                            image: undefined, // <null/String[URL]> image
                            imageLabel: '', // <String> image label
                            imageDescription: '', // <String> image description
                            isCorrect: undefined, // <Boolean> is correct
                        },
                    ],
                },
            ],
            results: [
                // <Array> results
                {
                    // <Object> results[i]
                    id: undefined, // <String> id
                    header: '', // <String> header
                    description: '', // <String> description
                    image: undefined, // <null/String[URL]> image
                    imageDisclaimer: '', // <String> image disclaimer,
                    buttonText: '', // <String> button text
                    buttonLink: '', // <String> button link
                },
            ],
        },
        defaultValues: {
            // settings
            settings: {
                showCover: true,
                distribution: [],
            },
            // cover
            cover: {
                image: null,
            },
            // questions
            questions: {
                image: null,
                answers: [],
                isText: true,
            },
            // questions.answers
            'questions.answers': {
                image: DEFAULT_IMAGE_URL,
                isCorrect: false,
            },
            // results
            results: {
                image: null,
            },
        },
    },
}

export const VALIDATION_RULES = {
    minQuestions: 1,
    maxQuestions: 30,
    minAnswersInQuestion: 2,
    maxAnswersInQuestion: 10,
    minCorrectAnswersInQuestion: 1,
    minIncorrectAnswersInQuestion: 1,
    minResults: 2,

    _fields: {
        // cover
        'cover.header': {
            required: true,
            maxLength: 400,
        },
        'cover.description': {
            required: false,
            maxLength: 500,
        },
        'cover.buttonText': {
            required: true,
            maxLength: 20,
        },
        'cover.image': {
            required: false,
        },
        'cover.imageDisclaimer': {
            required: false,
            maxLength: 100,
        },
        // questions
        'questions.text': {
            required: true,
            maxLength: 500,
        },
        'questions.image': {
            required: false,
        },
        'questions.imageDisclaimer': {
            required: false,
            maxLength: 100,
        },
        // questions.answers
        'questions.answers.text': {
            required: questions => questions.isText,
            maxLength: 500,
        },
        'questions.answers.imageLabel': {
            required: false,
            maxLength: 40,
        },
        'questions.answers.image': {
            required: questions => !questions.isText,
        },
        'questions.answers.description': {
            required: false,
            maxLength: 500,
        },
        'questions.answers.imageDescription': {
            required: false,
            maxLength: 80,
        },
        // results
        'results.header': {
            required: true,
            maxLength: 500,
        },
        'results.description': {
            required: false,
            maxLength: 500,
        },
        'results.image': {
            required: false,
        },
        'results.imageDisclaimer': {
            required: false,
            maxLength: 100,
        },
    },
}
